import { Tab, TabContext, TabList, TabPanel } from '@monthio/react-components'
import { useState, VoidFunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'
import { CustomProfileCreation } from './CustomProfileCreation'
import { getFromLocalStorage, setLocalStorage } from './customProfileUtils'
import { PredefinedProfileSelector } from './PredefinedProfileSelector'
import { FlowPage } from '@monthio/design-system'
import styled from 'styled-components'

const STORAGE_KEY = 'PROFILE_TYPE_SELECTOR'
const TabPanelFix = styled(TabPanel)`
	${(props) => props.theme.breakpoints.down('sm')} {
		max-height: calc(100vh - 220px);
		overflow: auto;
	}
`

export const ProfileTypeSelector: VoidFunctionComponent<{
	monthioInternalBankId: number | null
	goBack: () => void
}> = ({ monthioInternalBankId, goBack }) => {
	const [tabValue, setTabValue] = useState(
		getFromLocalStorage<string>(STORAGE_KEY, 'profiles'),
	)
	const { t } = useTranslation()

	return (
		<TabContext value={tabValue}>
			<TabList
				value={tabValue}
				onChange={(event: React.ChangeEvent<{}>, value: number) => {
					const selected = String(value)
					setLocalStorage(STORAGE_KEY, selected)
					setTabValue(selected)
				}}
			>
				<Tab label={t('profileTypeSelector-tab-profiles')} value="profiles" />
				<Tab
					label={t('profileTypeSelector-tab-customProfile')}
					value="custom"
				/>
			</TabList>

			<TabPanelFix value="profiles">
				<PredefinedProfileSelector
					monthioInternalBankId={monthioInternalBankId}
				/>
			</TabPanelFix>
			<TabPanelFix value="custom">
				<CustomProfileCreation monthioInternalBankId={monthioInternalBankId} />
			</TabPanelFix>
			<FlowPage.Footer
				backButton={
					<FlowPage.BackButton
						ariaLabel={t('bankLogin-return-button-ariaLabel')}
						onClick={goBack}
					/>
				}
			/>
		</TabContext>
	)
}
